import { Paginator as ForgePaginator } from "@/vendor/Forge/dist";
import { styled } from "@stitches/react";

const PaginatorWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  marginRight: 12,

  "& > div:first-child": {
    color: "#7C7D7D",
  },
});

const HelperText = styled("div", {
  fontSize: 16,
  lineHeight: "20px",
});

export const ROWS_PER_PAGE = 20;

interface Props {
  currentPage: number;
  totalItems: number;
  rowsPerPage?: number;
  totalPages?: number;
  onPaginationChange: (pageCount: number) => void;
}

export const getRange = ({
  rowsPerPage = ROWS_PER_PAGE,
  currentPage,
  totalItems,
}: Omit<Props, "onPaginationChange">) => {
  const lowerRange = rowsPerPage * (currentPage - 1) + 1;
  const upperRange = rowsPerPage * currentPage;
  const trueUpperRange = upperRange > totalItems ? totalItems : upperRange;

  return `${lowerRange}-${trueUpperRange}`;
};

const Paginator = ({
  currentPage, // 1-based pagination
  totalItems,
  rowsPerPage = ROWS_PER_PAGE,
  totalPages,
  onPaginationChange,
}: Props) => {
  if (totalItems === 0) return null;


  return (
    <PaginatorWrapper>
      <HelperText>
        {getRange({ currentPage, totalItems, rowsPerPage })} of {totalItems}
      </HelperText>
      <ForgePaginator
        pageCount={totalPages}
        onSelectedIndexChange={onPaginationChange}
        selectedIndex={currentPage - 1}
      />
    </PaginatorWrapper>
  );
};

export default Paginator;
